$(document).ready(function () {
    //Slick slider
    $('.sliders-section .slider').each(function () {
        if ($(this).find('.shop-now').length) {
            $(this).slick({
                nextArrow: '<span class="arrow-next"><i class="far fa-chevron-right"></i><span>',
                prevArrow: '<span class="arrow-prev"><i class="far fa-chevron-left"></i></span>',
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1100,
                        settings: {
                            nextArrow: '<span class="arrow-next"><i class="far fa-chevron-right"></i><span>',
                            prevArrow: '<span class="arrow-prev"><i class="far fa-chevron-left"></i></span>',
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 750,
                        settings: {
                            nextArrow: '<span class="arrow-next"><i class="far fa-chevron-right"></i><span>',
                            prevArrow: '<span class="arrow-prev"><i class="far fa-chevron-left"></i></span>',
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        } else {
            $(this).parents('.sliders-section').remove();
        }
    });
});